import React from 'react'
import classNames from 'classnames'

import './styles.scss'
import { PACK_NUMBER } from '../../../helpers/utils'

const MoreLessButton = ({
  quantity,
  add,
  remove,
  item,
  subscription,
  minusEnabled = true,
  plusEnabled = true,
  disableAddBtn = false
}) => {
  return (
    <div className='more-less-container'>
      <div
        className={classNames('remove-btn', { disabled: !minusEnabled || quantity(item) === 0 })}
        onClick={e => { quantity(item) < 1 ? e.preventDefault() : remove(item, subscription) }}
      >
        -
      </div>
      <div className={classNames('quantity', { zero: quantity(item) === 0 })}>{quantity(item)}</div>
      <div
        className={classNames('add-btn', { disabled: !plusEnabled || (item.subscription_item && quantity(item) === PACK_NUMBER[subscription.type]) || disableAddBtn })}
        onClick={() => add(item, subscription)}
      >
        +
      </div>
    </div>
  )
}

export default MoreLessButton
